import { Component, EventEmitter, HostListener, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { IpcRenderService } from 'src/app/shared/services/ipc-render.service';

export interface DropdownIcons{
  plusIcon:boolean,
  dropdownVal:string,
  isBlankOption:boolean
 }
 
@Component({
  selector: 'app-ag-grid-custom-dropdown',
  templateUrl: './ag-grid-custom-dropdown.component.html',
  styleUrls: ['./ag-grid-custom-dropdown.component.scss']
})
export class AgGridCustomDropdownComponent implements ICellEditorAngularComp{
  @ViewChild("container", { read: ViewContainerRef }) public container;

  drpdownVal:any
  value: string;
  dropdownname:string
  dropdownvalue:any;
  isBlankOption:boolean=false;
  values:any;
  selcetedName:any
  valueChanged = new EventEmitter<string>();
  public params: any;

  constructor(public ipcRenderService : IpcRenderService){
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    const select =  document.querySelector("#custom_select_options") as HTMLSelectElement | any;
    if (event.key === "ArrowDown" && document.activeElement !== select) 
        event.preventDefault(); 
      
    if (event.key === "ArrowDown") 
    {
      if(select){
        select?.focus();
        if(this.ipcRenderService.isRunningInElectron == false) {
          // Attempt to use showPicker
          try {
            if(select.showPicker) {
              select.showPicker();
            } else {
              // Fallback to simulating a click if showPicker is not available
              select.click();
            }
          } catch (e) {
            console.error("showPicker or click simulation failed:", e);
            // Implement any fallback logic if needed
          }
        } else {
          // Handle the case when running in Electron
          // Fallback logic or other handling can be placed here
          select.click();
        }
      }
    }
    
  }

  refresh(params){
    console.log();
    
  }

  agInit(params: ICellEditorParams<any> & DropdownIcons): void {
    this.params = params;
    this.isBlankOption = this.params?.isBlankOption??false;
    const valuesOrFunction = params.colDef.cellEditorParams?.values;
    this.values = typeof valuesOrFunction === 'function' ? valuesOrFunction() : valuesOrFunction??[];  
    this.value = this.params.value != undefined ? this.params.value.toString() : '';
  }

  selected(item) {
    this.dropdownvalue = item;
    const valuesOrFunction = this.values;
    this.selcetedName = valuesOrFunction.find(a => a.id == item).name;
       const rowNode = this.params.node;
       const data = rowNode.data;
       data[this.params.colDef.field] = item;
      rowNode.setDataValue(this.params?.colDef?.field ,item);
    this.valueChanged.emit(this.dropdownvalue); 
  }
  
  cellValueChanged() {
    // Logic on cell value changed
   this.valueChanged.emit(this.value); 
  }

  getValue() {
    // if(this.params.colDef.field == "purityPer")
    // {
    //   return (this.value);
    // }
    // else
    // {
      return (this.value != undefined && this.value != null) ?  this.value.toString() : '';
    // }
    
  }
  isPopup?(): boolean {
    return false;
  }
  getPopupPosition?(): any {
    return 'under'
  }
  isCancelBeforeStart?(): boolean {
    return false;
  }
  isCancelAfterEnd?(): boolean {
    return false
  }
  focusIn?(): void {
  
  }
  focusOut?(): void {
  
  }
  afterGuiAttached?(): void {
    this.getValue()
  }
  ngOnInit(): void {
   
  }

  cellEditingStopped(event) {
    // Logic on cell editing stopped
  }

}
